"use client";

import { Icon } from "@repo/ui/components/icon";
import { cn } from "@repo/ui/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@repo/ui/tooltip";
import { motion } from "motion/react";
import { memo } from "react";

import { useAvatarPicker } from "./avatar-picker.context";
import { cleanName } from "./avatar-picker.helpers";

const CustomIconItem = memo(
  ({ icon, disabled }: { icon: string; disabled: boolean }) => {
    const { iconColor, setIcon } = useAvatarPicker();

    return (
      <Tooltip disableHoverablePopup>
        <TooltipTrigger
          disabled={disabled}
          className={cn(
            "flex items-center justify-center rounded-sm text-base leading-none",
            "size-6 cursor-pointer",
            !disabled && "hover:bg-muted",
            disabled && "pointer-events-none",
          )}
          onClick={() => setIcon(icon as any)}
        >
          <motion.div
            animate={{
              opacity: disabled ? 0.25 : 1,
              scale: disabled ? 0.6 : 1,
            }}
            transition={{ duration: 0.15 }}
          >
            <Icon.Custom
              name={icon as any}
              className="size-4"
              style={{ color: iconColor }}
            />
          </motion.div>
        </TooltipTrigger>
        <TooltipContent side="bottom">{cleanName(icon)}</TooltipContent>
      </Tooltip>
    );
  },
);

export const CustomIconsGrid = () => {
  const { iconsList } = useAvatarPicker();

  return (
    <div className="scrollbar-none grid grid-cols-12 place-items-center gap-0 overflow-y-auto p-2">
      {iconsList.map(({ icon, disabled }) => (
        <CustomIconItem key={icon} icon={icon} disabled={disabled} />
      ))}
    </div>
  );
};
